import { IdName } from '../../../shared';
import { InventoryLocation, Inventory } from '../models';

export class Product extends IdName {
    category: string;
    current: number;
    minimum: number;
    missQuantity: number;
    color: string;
    size: string;
    locations: Array<InventoryLocation>;
    locationsCount: number;
    inventory: Inventory;
    isSelectedForTransfer: boolean = false;
    addedToTransfer = false;
    quantity: number;
    errorInTransfer: boolean;


    constructor(data: Product) {
        super();
        Object.assign(this, data);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/shared/models/product.ts